// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const BatteryEmpty = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M29.78,28.25H7.64A3.64,3.64,0,0,1,4,24.61V15.39a3.64,3.64,0,0,1,3.64-3.64H29.54a3.64,3.64,0,0,1,3.64,3.64v.53l1.76.05A1.06,1.06,0,0,1,36,17v6.64a1.06,1.06,0,0,1-1.05,1.05H33.24l-.05.12A3.41,3.41,0,0,1,29.78,28.25ZM7.64,12.75A2.64,2.64,0,0,0,5,15.39v9.22a2.64,2.64,0,0,0,2.64,2.64H29.78a2.41,2.41,0,0,0,2.4-2.4,1.07,1.07,0,0,1,1.05-1.12h1.71L35,17,34.95,17H33.24a1.06,1.06,0,0,1-1.05-1.05v-.53a2.64,2.64,0,0,0-2.64-2.64Z" />
        </G>
    );
};

export default BatteryEmpty;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/battery-empty/index.js